var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 163.067,
    height: 160.639,
    viewBox: "0 0 163.067 160.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f79b1a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12701",
    "data-name": "Group 12701",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12699",
    "data-name": "Group 12699",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21327",
    "data-name": "Path 21327",
    d: "M170.386,262.846c0,5.737-1.772,10.388-3.961,10.388s-3.959-4.651-3.959-10.388c0,0,.225-22.423,3.959-55.826C170.16,240.423,170.386,262.846,170.386,262.846Z",
    transform: "translate(-84.891 -112.595)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21328",
    "data-name": "Path 21328",
    d: "M211.112,244.658c3.687,4.394,5.319,9.1,3.642,10.5s-6.023-1.016-9.71-5.412c0,0-14.239-17.322-32.851-45.31C196.526,227.628,211.112,244.658,211.112,244.658Z",
    transform: "translate(-80.02 -113.888)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21329",
    "data-name": "Path 21329",
    d: "M231.633,203.7c5.649,1,9.922,3.549,9.542,5.7s-5.268,3.093-10.918,2.1c0,0-22.042-4.117-54.291-13.594C209.511,200.029,231.633,203.7,231.633,203.7Z",
    transform: "translate(-78.131 -117.16)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21330",
    "data-name": "Path 21330",
    d: "M224.983,177.382s-19.531,11.016-50.327,24.484c27.062-19.936,46.367-31.344,46.367-31.344,4.969-2.868,9.883-3.657,10.977-1.763S229.952,174.513,224.983,177.382Z",
    transform: "translate(-78.787 -132.272)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21331",
    "data-name": "Path 21331",
    d: "M191.523,144.2c2.056.747,2.131,5.724.17,11.115,0,0-7.882,20.994-22.816,51.106,7.917-32.666,15.372-53.815,15.372-53.815C186.211,147.213,189.468,143.449,191.523,144.2Z",
    transform: "translate(-81.681 -144.103)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21332",
    "data-name": "Path 21332",
    d: "M146.773,144.2c2.055-.749,5.311,3.015,7.274,8.407,0,0,7.456,21.147,15.371,53.813-14.933-30.112-22.815-51.1-22.815-51.1C144.642,149.922,144.717,144.945,146.773,144.2Z",
    transform: "translate(-93.547 -144.103)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21333",
    "data-name": "Path 21333",
    d: "M124.432,177.382c-4.969-2.869-8.11-6.729-7.016-8.623s6.008-1.1,10.977,1.763c0,0,19.3,11.407,46.367,31.344C143.963,188.4,124.432,177.382,124.432,177.382Z",
    transform: "translate(-107.561 -132.272)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21334",
    "data-name": "Path 21334",
    d: "M120.343,203.7s22.121-3.672,55.665-5.795c-32.247,9.477-54.291,13.594-54.291,13.594-5.649,1-10.537.057-10.918-2.1S114.693,204.695,120.343,203.7Z",
    transform: "translate(-110.776 -117.16)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21335",
    "data-name": "Path 21335",
    d: "M172.437,204.439c-18.611,27.99-32.852,45.311-32.852,45.311-3.687,4.394-8.035,6.818-9.71,5.412s-.045-6.108,3.644-10.5C133.519,244.66,148.1,227.628,172.437,204.439Z",
    transform: "translate(-101.542 -113.888)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12700",
    "data-name": "Group 12700",
    transform: "translate(20.215 15.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21336",
    "data-name": "Path 21336",
    d: "M157.622,245.288c-1.427,4.106-3.854,6.994-5.419,6.45s-1.676-4.315-.249-8.421c0,0,5.742-15.992,16.728-38.969C163.041,229.184,157.622,245.288,157.622,245.288Z",
    transform: "translate(-110.872 -129.791)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21337",
    "data-name": "Path 21337",
    d: "M186.325,242.736c1.546,4.063,1.543,7.834-.006,8.424s-4.058-2.227-5.6-6.29c0,0-5.882-15.941-12.236-40.605C180.126,226.916,186.325,242.736,186.325,242.736Z",
    transform: "translate(-102.094 -129.832)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21338",
    "data-name": "Path 21338",
    d: "M211.205,218.528c3.8,2.119,6.218,5.01,5.41,6.456s-4.54.9-8.335-1.217c0,0-14.753-8.431-35.472-23.24C196.286,210.4,211.205,218.528,211.205,218.528Z",
    transform: "translate(-99.927 -131.704)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21339",
    "data-name": "Path 21339",
    d: "M215.832,193.637s-16.722,3.024-42.113,5c24.329-7.534,40.985-10.893,40.985-10.893,4.27-.816,7.984-.159,8.295,1.469S220.1,192.82,215.832,193.637Z",
    transform: "translate(-99.471 -138.282)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21340",
    "data-name": "Path 21340",
    d: "M202.482,164.153c1.286,1.048.1,4.628-2.646,8,0,0-10.864,13.064-29.046,30.9,13.8-21.409,24.394-34.689,24.394-34.689C197.93,164.991,201.2,163.107,202.482,164.153Z",
    transform: "translate(-100.938 -150.064)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21341",
    "data-name": "Path 21341",
    d: "M165.872,154.669c1.657-.024,3.051,3.48,3.114,7.827,0,0,.074,16.992-2.391,42.34-3.2-25.267-3.611-42.253-3.611-42.253C162.923,158.236,164.215,154.693,165.872,154.669Z",
    transform: "translate(-104.848 -154.669)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21342",
    "data-name": "Path 21342",
    d: "M141.226,172.856c-2.842-3.29-4.129-6.835-2.875-7.918s4.574.7,7.417,3.994c0,0,10.978,12.97,25.384,33.972C152.463,185.6,141.226,172.856,141.226,172.856Z",
    transform: "translate(-117.423 -149.685)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21343",
    "data-name": "Path 21343",
    d: "M132.509,188.738s16.747,2.878,41.283,9.707c-25.44-1.243-42.239-3.782-42.239-3.782-4.292-.693-7.556-2.581-7.292-4.217S128.219,188.045,132.509,188.738Z",
    transform: "translate(-124.246 -137.736)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21344",
    "data-name": "Path 21344",
    d: "M172.767,200.736c-20.285,15.4-34.788,24.254-34.788,24.254-3.732,2.227-7.447,2.88-8.3,1.456s1.489-4.382,5.221-6.609C134.9,219.836,149.582,211.277,172.767,200.736Z",
    transform: "translate(-121.61 -131.6)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21345",
    "data-name": "Path 21345",
    d: "M164.029,193l3.891,2.595,4.344-1.734-1.266,4.5,2.992,3.6-4.673.188-2.495,3.956-1.623-4.387-4.533-1.15,3.67-2.9Z",
    transform: "translate(-85.793 -119.617)",
    fill: "url(#radial-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaricon);
export default __webpack_public_path__ + "static/media/staricon.e4ba5ca9949ed82c67e0cb2a238f9d7b.svg";
export { ForwardRef as ReactComponent };